import { render, staticRenderFns } from "./TrailerRentalContainerChassis.vue?vue&type=template&id=183c9982&"
import script from "./TrailerRentalContainerChassis.vue?vue&type=script&lang=js&"
export * from "./TrailerRentalContainerChassis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports